export const brand = {
  name: 'Triplin',
  /** User-facing product name shown in UI copy only. */
  uiName: 'trplin',
  shortName: 'GM',
  /** Public marketing domain, printed on guide identity cards. */
  domain: 'trplin.com',
  tagline: 'Book verified local guides in India\u2019s golden triangle & holy cities',
  copyright: 'Triplin',
  description:
    'Connect with verified local guides in Agra, Delhi, Varanasi, Mathura, Vrindavan & Jaipur for authentic travel experiences.',
  logoUrl: '/images/trplin-logo.png',
  /** Dark wordmark on transparent bg — for light UI surfaces (no navy badge). */
  logoUrlOnLight: '/images/trplin-logo-dark.png',
} as const;
